/**
 * AdminStatusBadge — Uniforme status-pil voor alle admin lijsten.
 *
 * Vervangt losse STATUS_META cls-tabellen in BetalingsregelingenSection,
 * FactuurBetalingsopvolgingPanel, LifecycleStatusBadge etc. door één set
 * van semantisch benoemde tonen.
 *
 * Toepassing:
 *   <AdminStatusBadge tone="success" label="Actief" />
 *   <AdminStatusBadge tone="danger" label="Verlopen" outlined />
 *   <AdminStatusBadge tone="warning" size="xs" icon={AlertTriangle} label="> 30d" />
 *
 * Props:
 *   tone     "neutral" | "brand" | "success" | "warning" | "danger"
 *            | "info" | "muted" | "critical"
 *   label    string  (verplicht)
 *   icon     Lucide-component (optioneel)
 *   size     "xs" | "sm" | "md"
 *   outlined boolean  (border-only variant)
 *   testid   string
 */
import React from "react";

const TONE_STYLES = {
  neutral:  { solid: "bg-slate-100 text-slate-800 border-slate-200",     outline: "bg-white text-slate-700 border-slate-300"    },
  brand:    { solid: "bg-brand-50 text-brand-700 border-brand-100",       outline: "bg-white text-brand-500 border-brand-200"    },
  success:  { solid: "bg-emerald-50 text-emerald-800 border-emerald-200", outline: "bg-white text-emerald-700 border-emerald-300"},
  warning:  { solid: "bg-amber-50 text-amber-900 border-amber-200",       outline: "bg-white text-amber-800 border-amber-300"    },
  danger:   { solid: "bg-red-50 text-red-800 border-red-200",             outline: "bg-white text-red-700 border-red-300"        },
  info:     { solid: "bg-blue-50 text-blue-800 border-blue-200",          outline: "bg-white text-blue-700 border-blue-300"      },
  muted:    { solid: "bg-slate-50 text-slate-500 border-slate-200",       outline: "bg-white text-slate-400 border-slate-200"    },
  critical: { solid: "bg-red-950 text-white border-red-900",              outline: "bg-white text-red-800 border-red-800"        },
};

const SIZE_CLS = {
  xs: "text-[10px] px-2 py-0.5 gap-1",
  sm: "text-[11px] px-2.5 py-0.5 gap-1",
  md: "text-xs px-3 py-1 gap-1.5",
};

export default function AdminStatusBadge({
  tone = "neutral",
  label,
  icon: Icon,
  size = "sm",
  outlined = false,
  testid,
}) {
  const t = TONE_STYLES[tone] || TONE_STYLES.neutral;
  const style = outlined ? t.outline : t.solid;
  return (
    <span
      className={
        `inline-flex items-center rounded-full border font-chivo font-bold ` +
        `whitespace-nowrap ${style} ${SIZE_CLS[size] || SIZE_CLS.sm}`
      }
      data-testid={testid || "admin-status-badge"}
    >
      {Icon ? <Icon className="w-3 h-3" /> : null}
      {label}
    </span>
  );
}
